import { render } from "./VacationCalendar.vue?vue&type=template&id=961ca1da&scoped=true"
import script from "./VacationCalendar.vue?vue&type=script&lang=js"
export * from "./VacationCalendar.vue?vue&type=script&lang=js"

import "./VacationCalendar.vue?vue&type=style&index=0&id=961ca1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961ca1da"]])

export default __exports__